module.exports = __webpack_public_path__ + "static/media/vf_wouter_core.0f99a1fc.svg";